module.exports = __webpack_public_path__ + "assets/img/6.5db4700c.png";